import useTitle from "../../../../hooks/useTitle";
import KickoutLayout from "../shared/Layout/KickoutLayout";
import { useNavigate } from "react-router-dom";
import useGtmTracking from "../../../../hooks/useGtmTracking";

export default function PrincipalKickout() {
    useTitle("Thank you");

    useGtmTracking("Onboarding:AgencyKickout", "onboarding_principal_ineligible");

    const navigate = useNavigate();

    return (
        <KickoutLayout
            header="Thank you for completing this portion of the application."
        >
            <div className="container">
                <div>
                    <div className="col-sm-12">
                        <li className="alert-content" style={{ marginTop: "40px" }}>
                            <div className="h2 mb-5">
                                An associate authorized to sign the Agency Contract must continue from here.
                            </div>
                            <p className="mb-5">
                                We have sent an email to the authorized associate to review, sign, and submit the application.
                            </p>
                            <button
                                type="button"
                                className="btn btn--primary btn--full-mobile btn--pull-right"
                                onClick={() => {
                                    navigate('/agency-overview')
                                }}
                            >
                                <span>Return To Welcome Page</span>
                            </button>
                        </li>
                    </div>
                </div>
            </div>
        </KickoutLayout>
    );
}